/** ID prefix for 1.0 / B&W welfare rows (`welfare_cageid`). Must match backend `BW_WELFARE_IMAGE_ID_PREFIX`. */
export const BW_WELFARE_IMAGE_ID_PREFIX = 'bw-welfare-';

export function isBwWelfareImageId(id: string): boolean {
    return id.startsWith(BW_WELFARE_IMAGE_ID_PREFIX);
}

/** Image types that return merged B&W + color welfare history from the API. */
export const MERGED_WELFARE_IMAGES_TYPE = 'full-size-image';
